import { AudioTrack } from "providers/AudioProvider/types";
import { voicingSounds } from "providers/AudioProvider/dubSounding";

/**
 * Озвучки, которые расписание может играть, — с местом в колонке. Только звучащие: реплика без
 * файла оставила бы тишину, похожую на обрыв, а снятая с озвучки (⊘) и озвучка без реплики
 * оригинала звучали бы дублем, которого в видео нет (сборка их не берёт).
 */
export const soundingVoicings = (tracks: AudioTrack[]): { ind: number; track: AudioTrack }[] =>
    tracks.map((track, ind) => ({ ind, track })).filter(({ track }) => voicingSounds(track));

/**
 * Озвучки, которые берёт общий выбор (скорость, голос, сдвиг, «выбрать все»), — с местом в
 * колонке. Все, кроме озвучки без реплики оригинала: её русскую реплику удалили, в видео её быть
 * не должно, и с ней можно только удалить (🗑 на блоке). Переозвучить её общим проходом значило бы
 * заплатить за дубль, которого в видео нет (4119e839, ru_es, папка 1, 1:22, «Así es.», 02.10.2026).
 */
export const selectableVoicings = (tracks: AudioTrack[]): { ind: number; track: AudioTrack }[] =>
    tracks.map((track, ind) => ({ ind, track })).filter(({ track }) => track.orphan_voicing !== true);

export const getNextTrack = (currentIndex: number, tracks: AudioTrack[]): AudioTrack | null => {
  if (currentIndex === tracks.length - 1) {
    return null;
  }
  let nextTrack: AudioTrack | null = null;
  for (let i = currentIndex + 1; i < tracks.length; i++) {
    if (tracks[i].file) {
      nextTrack = tracks[i];
      break;
    }
  }
  return nextTrack;
};
